<template xmlns="http://www.w3.org/1999/html">
    <b-modal v-model="visible" size="lg">
        <template v-slot:modal-header="{ close }">
            <div class="row" style="width: 100%">
                <div class="col-md-10 offset-md-1 text-center d-flex justify-content-center">
                    <h3> {{ __('item_group_edit') }} <button-open-help-modal :color="'dark'" :in-extra-div="false" :helpName="analyzeType == 'sell'? 'ASA-005' : 'ASB-005'"/> </h3>
                </div>
                <div class="col-md-1">
                    <button type="button" class="close" v-on:click="visible = false">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">{{ __('close') }}</span>
                    </button>
                </div>
            </div>
        </template>

        <template v-slot:default="{}">
            <div v-for="(group, index) in itemGroups" :key="index" class="mt-3">
                <div class="ibox-title" style="height: 30px !important;padding: 5px 5px 3px 15px">
                    <p class="group-container text-bold">{{ group.name == 'unallocated' ? __('unallocated_group') : group.name }} <span class="text-right">
                        <span class="tooltip-more icon-danger" v-if="group.name != 'unallocated' && group.name.length > 32"
                              :data-original-title=" __('too_long_group_name') "
                              :data-toggle="'tooltip'"
                              :data-placement="'top'">
                                <i class="fas fa-exclamation-triangle" style="color:red !important;"></i>
                            </span>
                         <a v-if="group.name != 'unallocated'"
                             class=""
                             :data-toggle="'tooltip'"
                             :data-placement="'top'"
                             :data-original-title="__('edit_name')"
                             @click="editGroupName(group.name)"
                         >
                            <i class="fa fa-pen text-white"></i>
                        </a>
                        <a v-if="canMoveDown(index,group)"
                           class="reorder arrow-down "
                           :data-toggle="'tooltip'"
                           :data-placement="'top'"
                           :data-original-title="__('move_down')"
                           @click="moveGroupDown(index)"
                        >
                            <i class="fas fa-arrow-down text-white"></i>
                        </a>
                         <a
                             v-if="canMoveUp(index,group)"
                             class="reorder arrow-up"
                             :data-toggle="'tooltip'"
                             :data-placement="'top'"
                             :data-original-title="__('move_up')"
                             @click="moveGroupUp(index)"
                         >
                            <i class="fas fa-arrow-up text-white"></i>
                        </a>
                         <a v-if="group.name != 'unallocated'"
                            class="icon-delete-embedded"
                            data-toggle="tooltip"
                            data-placement="top"
                            :data-original-title="__('delete')"
                            @click="showSwalDelete(group, index)"
                         >
                             <i class="fa fa-trash text-white"></i>
                        </a>
                    </span></p>

                </div>
                <div v-for="standard_item in group.standard_items" v-if="group.standard_items.length > 0 && standard_item.id != undefined" :key="standard_item.id" class="row mt-1">
                    <div class="col max-w-40">
                        <input type="checkbox" v-model="standard_item.checked">
                    </div>
                    <div class="col text-wrap" style="word-break: break-all" v-html="getDescription(standard_item)">
                    </div>
                </div>
            </div>


        </template>
        <template v-slot:modal-footer="{}">
            <div class="d-flex w-100">
                <div class="d-flex gap-3 flex-grow-1">
                    <div class=" white-space-no-wrap" v-if="checkedItems > 0">
                        <button type="button" class="btn btn-primary" @click="assignItemsToGroup()">{{__('assign_to_group')}}</button>
                    </div>
                    <div class=" white-space-no-wrap ml-2">
                        <button type="button" class="btn btn-primary" @click="createGroup()">{{__('create_group')}}</button>
                    </div>
                    <div class=" white-space-no-wrap ml-2" v-if="patternId == null">
                        <button type="button" class="btn btn-primary" @click="importItemGroups()">{{__('import_groups')}}</button>
                    </div>
                </div>
                <div class="d-flex gap-3">
                    <div class="col white-space-no-wrap ml-2">
                        <button type="button" class="btn btn-white" v-on:click="visible = false">{{__('cancel')}}</button>
                    </div>
                    <div class="col white-space-no-wrap">
                        <button type="button" class="btn btn-primary" @click="saveitemGroups()">{{__('save')}}</button>
                    </div>

                </div>

            </div>
        </template>
    </b-modal>
</template>
<style>
.group-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
<script>

import Numeric from "vuelidate/lib/validators/numeric";

export default {
    name: "ModalEditItemGroup",
    data: function () {
        return {
            visible: false,
            itemGroups: [],
        }
    },
    props: {
        groups: {
            type: Array
        },
        analyzeType: {
            type: String
        },
        patternId:{
            type:Numeric,
            default: null,
        }
    },
    methods: {
        editGroupName(name){
            this.$emit('editItemGroupName', name);
        },
        importItemGroups(){
            toggleLoader()
            this.$emit('importItemGroups', this.itemGroups);
        },
        getDescription(item) {
            let str = item.symbol;
            if (item.item_name) {
                str += ', <b>' + item.item_name + '</b>'
            }
            if (item.classification) {
                str += ', ' + item.classification
            }
            if (item.description) {
                str += ', ' + item.description
            }
            return str;
        },
        canMoveDown(index, group) {
            if (group.name == 'unallocated') {
                return false;
            }
            const unallocatedIndex = this.itemGroups.findIndex(group => group.name === 'unallocated');
            if (index == unallocatedIndex - 1) {
                return false;
            }
            if (index == this.itemGroups.length - 1) {
                return false;
            }
            return true;
        },
        canMoveUp(index, group) {
            if (group.name == 'unallocated') {
                return false;
            }
            const unallocatedIndex = this.itemGroups.findIndex(group => group.name === 'unallocated');
            if (index == 0) {
                return false;
            }
            return true;
        },
        moveGroupDown(index) {
            if (index < this.itemGroups.length - 1) {
                const temp = _.cloneDeep(this.itemGroups);
                const groupToMove = temp[index];
                temp[index] = temp[index + 1];
                temp[index + 1] = groupToMove;
                this.itemGroups = temp;
            }
        },
        moveGroupUp(index) {
            if (index <= this.itemGroups.length - 1) {
                const temp = _.cloneDeep(this.itemGroups);
                const groupToMove = temp[index];
                temp[index] = temp[index - 1];
                temp[index - 1] = groupToMove;
                this.itemGroups = temp;
            }
        },
        showSwalDelete(group, index) {
            let self = this;
            this.$swal({
                title: '',
                text: self.__("delete_allocation_group"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: self.__("delete"),
                cancelButtonText: self.__("cancel"),
                closeOnConfirm: true,
                reverseButtons: true
            }).then(result => {
                if (result.value === true) {
                    self.handleDeleteGroup(group, index);
                }
            });
        },
        handleDeleteGroup(group, index) {
            let unallocatedGroupIndex = this.itemGroups.findIndex(group => group.name === 'unallocated');
            if (unallocatedGroupIndex == -1) {
                this.itemGroups.push({name: 'unallocated', standard_items: []})
                unallocatedGroupIndex = this.itemGroups.findIndex(group => group.name === 'unallocated')
            }
            for (let i = 0; i < this.itemGroups[index].standard_items.length; i++) {
                const standardItem = this.itemGroups[index].standard_items[i];
                this.itemGroups[unallocatedGroupIndex].standard_items.push(standardItem);
            }
            this.itemGroups.splice(index, 1);
        },
        assignItemsToGroup(){
            this.$emit('assignItemsToGroup', this.itemGroups);
        },
        createGroup(){
            this.$emit('createItemGroup', this.itemGroups);
        },
        saveitemGroups(){
            toggleLoader()
            this.$emit('saveItemGroups', this.itemGroups);
        }
    },
    computed:{
        checkedItems(){
            let sumCheckedItems = 0;

            this.itemGroups.forEach(group => {
                if(group.standard_items.length > 0){
                    group.standard_items.forEach(standardItem => {
                        if (standardItem.checked) {
                            sumCheckedItems++;
                        }
                    });
                }
            });
            return sumCheckedItems
        }
    }
}
</script>

<style scoped>

</style>
